

import { Skeleton } from "../../../components/ui/skeleton";
import { useChampignonForm } from "../hooks";
import { ChampignonFormFields } from "./champignon-form-fields";

interface CreateChampignonFormProps {
  onCancel: () => void;
  onSuccess: () => void;
}

export function CreateChampignonForm({ onCancel, onSuccess }: CreateChampignonFormProps) {
  const {
    form,
    error,
    isEditing,
    isLoading,
    isSubmitting,
    isSaving,
    isUploading,
    isOptimizingImage,
    uploadProgress,
    compressionMessage,
    canRetryUpload,
    previewUrl,
    handleImageChange,
    onSubmit,
    retryUpload,
  } = useChampignonForm({ onSuccess });

  if (isLoading) {
    return (
      <div className="space-y-4">
        <Skeleton className="h-8 w-1/3" />
        <div className="space-y-4">
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-10 w-full" />
          <Skeleton className="h-20 w-full" />
        </div>
      </div>
    );
  }

  return (
    <ChampignonFormFields
      form={form}
      error={error}
      isEditing={isEditing}
      isSubmitting={isSubmitting}
      isSaving={isSaving}
      isUploading={isUploading}
      isOptimizingImage={isOptimizingImage}
      uploadProgress={uploadProgress}
      compressionMessage={compressionMessage}
      canRetryUpload={canRetryUpload}
      previewUrl={previewUrl}
      onCancel={onCancel}
      handleImageChange={handleImageChange}
      onSubmit={onSubmit}
      retryUpload={retryUpload}
    />
  );
}
